import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-grupo-radiobutton',
  templateUrl: './grupo-radiobutton.component.html',
  styleUrls: ['./grupo-radiobutton.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GrupoRadiobuttonComponent),
      multi: true
    }]
})

export class GrupoRadiobuttonComponent implements OnInit, ControlValueAccessor {

  ngOnInit(): void {
    this.modelValue = this.valor_defecto;
  }

  @Input("descripcion_etiqueta") descripcion_etiqueta = "Grupo de radio";
  @Input("opciones") opciones: { value: string, texto: string }[];
  @Input("valor_defecto") valor_defecto: "";
  @Input() texto_complementario: "";
  @Input() mensaje_error: "";

  @Output("modelValueChange") modelValueChange: EventEmitter<string> = new EventEmitter<string>();

  modelValue: any = ""
  private onChange = (value: boolean) => { };
  private onTouched = () => { };

  writeValue(value): void {
    this.modelValue = value || "";
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onInputChange(value: any): void {
    this.modelValue = value;
    // Notifica al ControlValueAccessor sobre el cambio de valor
    this.onChange(value);
  }
}
